import React from 'react';
import { TooltippedButtonWrapper, TooltippedButtonWrapperProps } from '@tanium/react-button-base';
import { Checkbox, Props as CheckboxProps } from './Checkbox';

export interface TooltippedCheckboxProps
  extends CheckboxProps,
    Pick<
      TooltippedButtonWrapperProps,
      'tooltipContent' | 'tooltipModifiers' | 'tooltipPlacement'
    > {}

const TooltippedCheckboxInner = React.forwardRef<HTMLInputElement, TooltippedCheckboxProps>(
  ({ tooltipContent, tooltipModifiers, tooltipPlacement, ...props }, forwardedRef) => (
    <TooltippedButtonWrapper
      tooltipContent={tooltipContent}
      tooltipModifiers={tooltipModifiers}
      tooltipPlacement={tooltipPlacement}
      disabled={props.disabled}
    >
      <Checkbox {...props} ref={forwardedRef} />
    </TooltippedButtonWrapper>
  ),
);

TooltippedCheckboxInner.displayName = 'TooltippedCheckbox';

/**
 * A version of
 * [Checkbox](https://pages.git.corp.tanium.com/eng/ufe/?path=/docs/core-ui-components-checkbox)
 * that supports showing a tooltip on hover.
 *
 * Use this component if you need to show a tooltip when the user hovers over a
 * checkbox. In particular, this component handles showing a tooltip even if the
 * checkbox is disabled.
 */
// This type cast provides better typings and Intellisense for consumers
export const TooltippedCheckbox = TooltippedCheckboxInner as React.VFC<
  TooltippedCheckboxProps & { ref?: React.Ref<HTMLInputElement> }
>;
